import React, { useCallback, useState } from "react";
import styles from "./CustomPackageNotif.module.scss";
import { strings } from "intl/fa";
import { Button, ButtonSize, ButtonVariant, CloseIcon } from "@bale/ui";
import PackagesModal from "components/content/packagesPage/PackagesModal";
import { PackageItem } from "components/content/packagesPage/PackageItem";
import FullpageModal from "components/commons/modal/fullpageModal/FullpageModal";
import ReactDOM from "react-dom";
import { FeatureScope } from "core/auth/auth.entity";
import { useFeatureScopes } from "hooks/useFeatureScopes";
import { digitsToHindi } from "@bale/utils";
import { useTheme } from "@emotion/react";
import { PackageInfo } from "components/content/packagesPage/packages";

function CustomPackageNotif(props: { packageInfo: PackageInfo }) {
  const theme = useTheme();
  const [showAllPackages, setShowAllPackages] = useState(false);
  const [showCustomPack, setShowCustomPack] = useState(false);

  const isFestival = useFeatureScopes(FeatureScope.Festival);

  const showCustomPackDetail = useCallback(() => {
    setShowCustomPack(true);
  }, []);

  const showOtherPacks = useCallback(() => {
    setShowAllPackages(true);
  }, []);

  return (
    <div data-testid="custom-package-notif" className={styles.NotifCard}>
      <p className={styles.NewNotif}>
        {strings.side_bar.custom_pack_notif.new_notif}
      </p>
      <p
        style={{
          color: isFestival
            ? theme.colors.alternative[3]
            : theme.colors.dark[500],
        }}
        className={styles.NotifTitle}
      >
        {isFestival
          ? strings.side_bar.yalda_package.title
          : strings.side_bar.custom_pack_notif.your_custom_pack}
      </p>
      <p className={styles.NotifDesc}>
        {isFestival
          ? strings.side_bar.yalda_package.description
          : strings.side_bar.custom_pack_notif.pack_created_by_admin}
      </p>
      <Button
        className={styles.NotifButton}
        size={ButtonSize.Small}
        variant={ButtonVariant.Outlined}
        onClick={showCustomPackDetail}
      >
        {strings.common.button.more_info}
      </Button>
      <p className={styles.OtherPacks} onClick={showOtherPacks}>
        {strings.side_bar.custom_pack_notif.other_packs}
      </p>
      {showCustomPack &&
        ReactDOM.createPortal(
          <FullpageModal>
            <div className={styles.CloseIcon}>
              <CloseIcon size={32} onClick={() => setShowCustomPack(false)} />
            </div>
            <p className={styles.FullModalTitle}>
              {isFestival
                ? strings.packages.yalda.title
                : strings.packages.sidebar.your_package}
            </p>
            {isFestival ? (
              <p className={styles.FullModalDesc}>
                <span className={styles.FullModalDesc}>
                  {strings.packages.yalda.description1}
                </span>
                <span className={styles.FullModalDesc}>
                  {digitsToHindi(strings.packages.yalda.description2)}{" "}
                </span>
                <span className={styles.FullModalDesc}>
                  {strings.packages.yalda.description3}
                </span>
              </p>
            ) : (
              <p className={styles.FullModalDesc}>
                {strings.packages.modal.buy_new_pack_desc}
              </p>
            )}
            <PackageItem
              // isYalda={isFestival}
              package={props.packageInfo}
              closeModal={() => setShowCustomPack(false)}
            />
          </FullpageModal>,
          document.getElementById("fullscreen-modal")!
        )}
      {showAllPackages &&
        ReactDOM.createPortal(
          <PackagesModal onClose={() => setShowAllPackages(false)} />,
          document.getElementById("fullscreen-modal")!
        )}
    </div>
  );
}

export default CustomPackageNotif;
